<template>
  <!--START TESTIMONIAL-->
  <section class="section pt-4 scroll-select" id="team">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <h1 class="section-title text-center">
            Por trás dos bastidores da Startandu
          </h1>
          <div class="section-title-border margin-t-20"></div>
          <p
            class="section-subtitle text-muted text-center font-secondary padding-t-30"
          >
            Temos um time divertido, unido, criativo, bem humorado, inteligente
            e especializado nas mais diversas áreas passando por marketing,
            desenvolvimento de software, consultoria empresarial, financeira,
            jurídica e muito mais.
          </p>
        </div>
      </div>
      <div class="row margin-t-50">
        <div class="col-lg-3 col-sm-6">
          <div class="team-box text-center hover-effect">
            <div class="team-wrapper">
              <div class="team-member">
                <img
                  alt=""
                  src="images/team/img-1.jpg"
                  class="img-fluid rounded"
                />
              </div>
            </div>
            <h4 class="team-name">Leilane Santos</h4>
            <p class="text-uppercase team-designation">Arquiteta de Software</p>
          </div>
        </div>

        <div class="col-lg-3 col-sm-6">
          <div class="team-box text-center hover-effect">
            <div class="team-wrapper">
              <div class="team-member">
                <img
                  alt=""
                  src="images/team/img-2.jpg"
                  class="img-fluid rounded"
                />
              </div>
            </div>
            <h4 class="team-name">Catarina Santiago</h4>
            <p class="text-uppercase team-designation">Gerente de Produto</p>
          </div>
        </div>

        <div class="col-lg-3 col-sm-6">
          <div class="team-box text-center hover-effect">
            <div class="team-wrapper">
              <div class="team-member">
                <img
                  alt=""
                  src="images/team/img-3.jpg"
                  class="img-fluid rounded"
                />
              </div>
            </div>
            <h4 class="team-name">Daniel Gouveia dos Santos</h4>
            <p class="text-uppercase team-designation">Consultor Financeiro</p>
          </div>
        </div>

        <div class="col-lg-3 col-sm-6">
          <div class="team-box text-center hover-effect">
            <div class="team-wrapper">
              <div class="team-member">
                <img
                  alt=""
                  src="images/team/img-4.jpg"
                  class="img-fluid rounded"
                />
              </div>
            </div>
            <h4 class="team-name">Jarilene Nascimento</h4>
            <p class="text-uppercase team-designation">
              Coach jurídica e Quântica
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--END TESTIMONIAL-->
</template>

<script>
"use strict";
export default {
  name: "Testimonial2",
  props: {}
};
</script>
